import { NibbleCreateModel } from '@aipb/personal-content/shared/model';
import { AsyncDialog, DialogConfig } from '@aipb/dialog';
import { Injectable } from '@angular/core';
import { CreateEditNibbleDialogDataModel } from './create-edit-nibble-dialog-data.model';
import { CreateEditNibbleDialogComponent } from './create-edit-nibble-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CreateEditNibbleDialogService extends AsyncDialog<
  CreateEditNibbleDialogComponent,
  CreateEditNibbleDialogDataModel,
  NibbleCreateModel
> {
  async loadComponent() {
    return import('./create-edit-nibble-dialog.component').then((r) => r.CreateEditNibbleDialogComponent);
  }

  dialogConfig(): DialogConfig {
    return {
      width: '80vw'
    };
  }
}
